import { all, call, put, takeLatest } from 'redux-saga/effects'

import { startLoading, stopLoading } from 'components/Loader/LoaderPopup/reducer'
import { setErrorMessage, setSuccessMessage } from 'components/Windows/CentralMessagesList/reducer'
import { callApiAsync } from 'services/api/callAPIAsync'
import { changePassword } from './reducer'

function* changePasswordCallSaga(action) {
    const old_password = action?.payload?.oldPassword
    const new_password = action?.payload?.newPassword
    yield put(startLoading())
    const { error } = yield call(callApiAsync, 'changePassword', { old_password, new_password })
    yield put(stopLoading())
    if (error) {
        yield put(setErrorMessage(error))
        console.error(error)
        return
    }
    yield put(setSuccessMessage('PASSWORD_CHANGED'))
}

export default function* changePasswordSaga() {
    yield all([takeLatest(changePassword.type, changePasswordCallSaga)])
}
